<template>
  <v-chip
    :small="small"
    :x-small="!small"
    label
    outlined
    :color="chip.color"
    class="folder-run-freshness"
    :class="`folder-run-freshness--${chip.state}`"
    :title="tooltip"
  >
    <v-icon :x-small="!small" :small="small" left>{{ chip.icon }}</v-icon>
    {{ chip.label }}
  </v-chip>
</template>

<script>
import { describeOutdatedEngines, freshnessChip } from '@/utils/folderRuns';

/**
 * Freshness of a Folder Run: Current / Outdated / Config derived / Unknown provenance.
 *
 * The backend sends a short English `detail` sentence with the state; it is shown as the chip
 * title so the reason is one hover away instead of hidden in a detail page.
 */
export default {
  name: 'FolderRunFreshnessChip',

  props: {
    /** The `freshness` block of a FolderRunSummary (a bare state string also works). */
    freshness: { type: [Object, String], default: null },
    small: { type: Boolean, default: false },
  },

  computed: {
    chip() {
      return freshnessChip(this.freshness);
    },
    tooltip() {
      const parts = [this.chip.detail];
      const outdated =
        this.freshness && typeof this.freshness === 'object' ? this.freshness.outdated_engines : [];
      const described = describeOutdatedEngines(outdated);
      if (described) parts.push(described);
      const newer =
        this.freshness && typeof this.freshness === 'object'
          ? this.freshness.newer_config_version
          : null;
      if (newer != null) parts.push(`Newer configuration available: v${newer}`);
      return parts.filter(Boolean).join(' — ');
    },
  },
};
</script>

<style scoped>
.folder-run-freshness {
  font-weight: 600;
}
</style>
